<template>
  <div class="card">
    <div class="card-header">
      <h4 class="title">Terminals</h4>
    </div>
    <div class="card-body">
      <v-server-table :url="`/v1/terminals?_expand=driver`" :columns="columns" :options="options">
        <template slot="id" slot-scope="props">
          <code>{{ props.row.id }}</code>
        </template>

        <template slot="serialNumber" slot-scope="props">
          <code>{{ props.row.serialNumber }}</code>
        </template>

        <template slot="driverId" slot-scope="props">
          <div v-if="props.row.driverId && props.row.driver">
            <router-link :to="`/account/drivers/${props.row.driverId}`">{{ props.row.driver.name }}</router-link>
          </div>
        </template>

        <template slot="createdAt" slot-scope="props">
          <div>{{ props.row.createdAt | moment('YYYY-MM-DD HH:mm A') }}</div>
        </template>

        <template slot="lastSeenAt" slot-scope="props">
          <div>{{ props.row.lastSeenAt | moment('from', 'now') }}</div>
        </template>

        <template slot="links" slot-scope="props">
          <router-link :to="`/account/terminals/${props.row.id}`" class="btn btn-default btn-sm">
            View &nbsp;
            <i class="fa fa-chevron-right"></i>
          </router-link>
        </template>
      </v-server-table>
    </div>
  </div>
</template>
<script>
import _ from "lodash";

const columns = [
  "id",
  "serialNumber",
  "createdAt",
  "driverId",
  "isAllocated",
  "isUpToDate",
  "lastSeenAt",
  "links"
];

export default {
  name: "SalesList",
  data() {
    return {
      columns,
      options: {
        columnsDropdown: false,
        headings: {
          id: "Terminal ID",
          serialNumber: "Serial Number",
          createdAt: "Registered",
          isAllocated: "Allocated?",
          isUpToDate: "Updated?",
          driverId: "Allocation",
          lastSeenAt: "Last online"
        },
        sortable: _.initial(columns),
        filterable: _.initial(columns),
        listColumns: {
          isAllocated: [
            {
              id: "true",
              text: "Allocated"
            },
            {
              id: "false",
              text: "Unallocated"
            }
          ],
          isUpToDate: [
            {
              id: "true",
              text: "Up to date"
            },
            {
              id: "false",
              text: "Out of date"
            }
          ]
        }
      }
    };
  }
};
</script>